import {truncateToDecimalPlaces} from './numberFormatter';

interface EstimateContractQuantityParams {
    amount: number;
    leverage: number;
    price: number;
    ctVal?: number;
    lotSz?: number;
    minSz?: number;
}

export function estimateContractQuantity({
                                             amount,
                                             leverage,
                                             price,
                                             ctVal,
                                             lotSz,
                                             minSz
                                         }: EstimateContractQuantityParams): number {
    if (!amount || amount <= 0 || !leverage || leverage <= 0 || !price || price <= 0) {
        return 0;
    }

    const contractValue = price * (ctVal && ctVal > 0 ? ctVal : 1);
    if (!contractValue || contractValue <= 0) {
        return 0;
    }

    const rawQuantity = (amount * leverage) / contractValue;
    if (!isFinite(rawQuantity) || rawQuantity <= 0) {
        return 0;
    }

    const effectiveLotSz = lotSz && lotSz > 0 ? lotSz : undefined;
    const effectiveMinSz = minSz && minSz > 0 ? minSz : undefined;

    let normalizedQuantity = rawQuantity;
    if (effectiveLotSz) {
        normalizedQuantity = Math.floor(rawQuantity / effectiveLotSz) * effectiveLotSz;
    }

    if (effectiveMinSz && normalizedQuantity > 0 && normalizedQuantity < effectiveMinSz) {
        normalizedQuantity = effectiveMinSz;
    }

    return truncateToDecimalPlaces(normalizedQuantity, 8);
}
